import corteReducer from './corteReducer';

export default corteReducer;